import React, { Component } from 'react';
import moment from 'moment';

class Results extends Component {
  actionResult = () => {
    console.log('action');
  };

  render() {
    const { order, legend } = this.props;
    return (
      <div className="results-search">
        <div>
          <p className="font-bold combo-list-trade">
            {order.codLastRequest}
            {' '}
-
            {moment(order.dateOrder).format('DD/MM/YYYY')}
          </p>
          {order.orderId !== 0 && <p className="legend-combo-list-trade">{legend}</p>}
        </div>
        <div>
          <a
            href="/pedidos/trade"
            className="link-dm pointer"
            title="Ver Pedido"
          >
            Ver Pedidos
          </a>
        </div>
      </div>
    );
  }
}

export default Results;



// WEBPACK FOOTER //
// ./src/components/trades/results.jsx